import '@/components/reusable/RPlayerProgressBar';
import './WPlayerQueue.js';
import volumeIcon from '@/assets/images/volume.svg';
import '@/components/reusable/RPlayButton';
import './WPlayerExtended';
import './types.js';
import { UITrackMixin } from '@/mixins/UITrackMixin.js';
import './WPlayerExtended';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
  :host {
    --play-button-size: 36px;
    --play-icon-size: 20px;
    display: flex;
    align-items: center;
    padding: 10px 20px;
    justify-content: space-between;
    gap: 30px;
    border-top: 1px solid lightgray;
    background-color: var(--color-block);
  }
  
  .left {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }
  
  .middle {
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex-grow: 1;
  }
  
  .duration {
    margin-left: auto;
  }
  
  .buttons {
    margin-left: 10px;
    display: flex;
    gap: 5px;
  }
  
  .buttons button {
    width: 24px;
    height: 24px;
    outline: none;
    background: transparent;
    padding: 0;
    border: none;
  }
  
  r-play-button {
    margin-right: 20px;
  }
`);
export class WPlayer extends UITrackMixin(HTMLElement) {
    static tag = 'w-player';
    /** @type {Track} */
    _track;
    /** @param {Track} track */
    constructor({ track } = {}) {
        super({ track });
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [styleSheet];
        this.shadowRoot.innerHTML = `
      <div class="left">
        <r-play-button class="toggler"></r-play-button>
        <div class="middle">
          <div class="title"></div>
          <r-player-progress-bar></r-player-progress-bar>
        </div>
<!--        <div class="duration"></div>-->
        <div class="buttons">
<!--          <button class="volume">-->
<!--            <r-icon url="${volumeIcon}"></r-icon>-->
<!--          </button>-->
        </div>
      </div>
      <div class="right">
        <r-menu-button></r-menu-button>
<!--        <w-player-queue class="queue"></w-player-queue>-->
      </div>
    `;
        this.track = track;
    }
    connectedCallback() {
        super.connectedCallback();
        this.#updateTrack();
        this.#processSongPlayToggle();
        this.shadowRoot.querySelector('r-menu-button').addEventListener('click', () => {
            const el = document.createElement('w-player-extended');
            el.value = { cover: '' };
            document.body.append(el);
        });
    }
    pause() {
        super.pause();
    }
    play() {
        super.play();
    }
    /** @param {Track} track */
    set track(track) {
        this._track = track;
        if (this.isConnected) {
            this.#updateTrack();
        }
    }
    get track() {
        return this._track;
    }
    visualPause() {
        this.shadowRoot.querySelector('r-play-button').isPlaying = false;
    }
    visualPlay() {
        this.shadowRoot.querySelector('r-play-button').isPlaying = true;
    }
    /** @param {number} duration */
    #formatDuration(duration) {
        const fullHours = Math.floor(duration / 1000 / 60 / 60);
        const fullMinutes = Math.floor((duration - fullHours * 1000 * 60 * 60) / 1000 / 60);
        const fullSeconds = Math.floor((duration - fullHours * 60 * 60 * 1000 - fullMinutes * 60 * 1000) / 1000);
        const str = `${fullMinutes.toString().padStart(2, '0')}:${fullSeconds.toString().padStart(2, '0')}`;
        return fullHours > 0 ? `${fullHours}:${str}` : str;
        // return `02:00`;
    }
    #processSongPlayToggle() {
        const $toggler = /** @type {HTMLButtonElement} */ this.shadowRoot.querySelector('.toggler');
        $toggler.addEventListener('click', () => {
            if (this.isTrackPlaying)
                this.pause();
            else
                this.play();
        });
    }
    #updateTrack() {
        this.shadowRoot.querySelector('.title').innerText = this.track.title;
    }
}
customElements.define(WPlayer.tag, WPlayer);
